import { OpenAPI } from '@hubblecommerce/hubble/platforms/shopware/api-client'
import { request as __request } from '@hubblecommerce/hubble/platforms/shopware/request'

/*
Usage:

const { recaptcha } = useRecaptchaV3()
let isNotABot = await recaptcha()

if (isNotABot) {
    submitForm()
} else {
    console.error('Recaptcha failed, please try again.')
}
*/

export function useRecaptchaV3 () {
    // @ts-ignore
    const config = useRuntimeConfig().public

    async function recaptcha() {
        // Allow form submission if env key is missing/empty
        if (config.googleRecaptchaSiteKey.trim() === '' || !config.googleRecaptchaSiteKey ) {
            return true
        }
        try {
            await initRecaptchaApi()

            const token = await executeRecaptcha()

            const response = await __request(OpenAPI, {
                method: 'POST',
                url: '/recaptcha',
                body: {
                    'g-recaptcha-response': token,
                }
            })

            // @ts-ignore
            if (response?.body != null && response?.body?.success === true) {
                // @ts-ignore
                const score = response?.body?.score

                if (typeof score === 'number') {
                    return score >= 0.3
                } else {
                    // Allow form submission if response is success but score is invalid
                    return true
                }
            }

            return false
        } catch (e) {
            console.warn('reCAPTCHA unavailable, allowing request:', e)
            // Allow form submission if reCAPTCHA service is unavailable
            return true
        }
    }

    async function executeRecaptcha() {
        try {
            // @ts-ignore
            return await window.grecaptcha?.execute(config.googleRecaptchaSiteKey, { action: 'submit' })
        } catch (e) {
            console.log(e)
        }
    }

    function initRecaptchaApi() {
        // @ts-ignore
        if (window.grecaptcha != null) {
            return
        }

        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement('script')
            scriptElement.type = 'text/javascript'
            scriptElement.src = `https://www.google.com/recaptcha/api.js?render=${config.googleRecaptchaSiteKey}`
            scriptElement.id = 'recaptcha-api'

            const timeout = setTimeout(() => {
                reject(new Error('reCAPTCHA script load timeout'))
            }, 5000)

            document.head.appendChild(scriptElement)

            scriptElement.addEventListener('load', () => {
                clearTimeout(timeout)
                // @ts-ignore
                window.grecaptcha?.ready(function () {
                    // @ts-ignore
                    resolve()
                })
            })

            scriptElement.addEventListener('error', () => {
                clearTimeout(timeout)
                reject(new Error(`${scriptElement.src} failed to load.`))
            })
        });
    }

    return {
        recaptcha,
        initRecaptchaApi
    }
}
